
import React, { useState } from 'react';
import RoomSection from './repat/RoomSection';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';

interface RepatFormProps {
  readOnly?: boolean;
}

const RepatForm = ({ readOnly = false }: RepatFormProps) => {
  const [showCamping, setShowCamping] = useState(false);

  return (
    <div className="space-y-6">
      <RoomSection 
        title="Habitaciones" 
        basePath="repat" 
        readOnly={readOnly} 
        showDepartmentField={true}
        showOthersField={true}
      />
      
      <RoomSection 
        title="Cabañas" 
        basePath="repat.cabins" 
        readOnly={readOnly} 
        showOthersField={true}
      />

      {/* Camping section */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Switch 
            id="camping-toggle"
            checked={showCamping}
            onCheckedChange={setShowCamping}
            disabled={readOnly}
          />
          <Label htmlFor="camping-toggle" className="font-medium">Camping</Label>
        </div>

        {showCamping && (
          <div className="form-group ml-6 mt-2">
            <Label className="form-label">Capacidad</Label>
            <Input 
              type="text" 
              className="form-input max-w-xs"
              disabled={readOnly}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RepatForm;
